
import CustomButton from "../../../common/CustomButton";

function SlidePreGoal({ moveNext }) {
    return (
        <div id="uo-pre-goal" className="uo-component div-45-55">
            <div id="uo-pg-animation-banner">
                <div id="uo-pg-ab-container">
                    <img src="/assets/images/onboarding/onboarding-pre-goal-banner.png" className="pi-banner" />
                </div>
            </div>

            <div id="uo-pg-text" className="bottom-text-area">
                <h4>Time to Set Your Goals!</h4>
                <h6>Did you know that recording your goals can increase your chance of success by 42%?</h6>
                <CustomButton className="uo-button active" onClick={moveNext}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SlidePreGoal;